import { useEffect, useRef, useState } from 'react';
import { useLang } from '../i18n';

function ExhaustIcon() {
  return (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 12h18"/><path d="M3 6h18"/><path d="M3 18h12"/><path d="M17 15l4 3-4 3"/>
    </svg>
  );
}
function FabricationIcon() {
  return (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="3"/><path d="M19.07 4.93A10 10 0 1 0 20 12"/><path d="M12 2v4"/><path d="M12 18v4"/><path d="M2 12h4"/><path d="M18 12h4"/>
    </svg>
  );
}
function CatIcon() {
  return (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="7" width="18" height="10" rx="4"/><line x1="3" y1="12" x2="21" y2="12"/><circle cx="8" cy="12" r="1"/><circle cx="12" cy="12" r="1"/><circle cx="16" cy="12" r="1"/>
    </svg>
  );
}
function HeaderIcon() {
  return (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M4 4h2v16H4"/><path d="M20 4h-2v16h2"/><path d="M6 7h12v2H6z"/><path d="M6 13h12v2H6z"/>
    </svg>
  );
}
function TunerIcon() {
  return (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="4" y="4" width="16" height="16" rx="3"/><line x1="9" y1="9" x2="15" y2="9"/><line x1="9" y1="12" x2="15" y2="12"/><line x1="9" y1="15" x2="13" y2="15"/><polyline points="14 15 17 18 20 15"/>
    </svg>
  );
}
function WrenchIcon() {
  return (
    <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z"/>
    </svg>
  );
}

const iconMap = { exhaust: ExhaustIcon, fabrication: FabricationIcon, cat: CatIcon, header: HeaderIcon, tuner: TunerIcon, wrench: WrenchIcon };

export default function Services() {
  const [visible, setVisible] = useState(false);
  const ref = useRef();
  const { t } = useLang();

  const services = [
    { title: t.svc1Title, description: t.svc1Desc, icon: 'exhaust' },
    { title: t.svc2Title, description: t.svc2Desc, icon: 'fabrication' },
    { title: t.svc3Title, description: t.svc3Desc, icon: 'cat' },
    { title: t.svc4Title, description: t.svc4Desc, icon: 'header' },
    { title: t.svc5Title, description: t.svc5Desc, icon: 'tuner' },
    { title: t.svc6Title, description: t.svc6Desc, icon: 'wrench' },
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) { setVisible(true); observer.disconnect(); } },
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="services-section sm-section" data-testid="services-section" ref={ref}>
      <div className="sm-container">
        <div className="reveal-item" style={visible ? { opacity: 1, transform: 'translateY(0)' } : {}}>
          <div className="section-label">{t.servicesLabel}</div>
          <h2 className="section-title">{t.servicesTitle}</h2>
          <p className="section-subtitle">{t.servicesSubtitle}</p>
        </div>
        <div className="services-grid" data-testid="services-grid">
          {services.map((service, i) => {
            const Icon = iconMap[service.icon];
            return (
              <div key={i} className="service-card reveal-item" style={{ transitionDelay: `${i * 70}ms`, ...(visible ? { opacity: 1, transform: 'translateY(0)' } : {}) }}>
                <div className="service-icon-wrapper"><div className="service-icon-inner"><Icon /></div></div>
                <h3>{service.title}</h3>
                <p>{service.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
